import { coerceTimeZone } from "./timezone";
export function localPartsInTimezone(tz, now) {
    var _a;
    const zone = coerceTimeZone(tz);
    const fmt = new Intl.DateTimeFormat("en-GB", {
        timeZone: zone,
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
    });
    const parts = Object.fromEntries(fmt.formatToParts(now).map((p) => [p.type, p.value]));
    const weekdayMap = {
        Mon: "mon",
        Tue: "tue",
        Wed: "wed",
        Thu: "thu",
        Fri: "fri",
        Sat: "sat",
        Sun: "sun",
    };
    const day = (_a = weekdayMap[parts.weekday]) !== null && _a !== void 0 ? _a : "mon";
    const hour = parts.hour === "24" ? "00" : parts.hour;
    const hhmm = `${hour}:${parts.minute}`;
    const ymd = `${parts.year}-${parts.month}-${parts.day}`;
    return { day, hhmm, ymd };
}
export function ruleMatches(rule, parts, roomId) {
    var _a;
    if (!rule.enabled)
        return false;
    if (!rule.scopeAllRooms) {
        if (!roomId)
            return false;
        if (!((_a = rule.roomIds) !== null && _a !== void 0 ? _a : []).includes(roomId))
            return false;
    }
    if (rule.startDate && parts.ymd < rule.startDate)
        return false;
    if (rule.endDate && parts.ymd > rule.endDate)
        return false;
    if (rule.daysOfWeek && rule.daysOfWeek.length > 0) {
        if (!rule.daysOfWeek.includes(parts.day))
            return false;
    }
    if (rule.startTime && parts.hhmm < rule.startTime)
        return false;
    if (rule.endTime && parts.hhmm >= rule.endTime)
        return false;
    return true;
}
export function activeScheduleFor(schedules, now, roomId, timezone) {
    if (!schedules || schedules.length === 0)
        return null;
    const parts = localPartsInTimezone(timezone, now);
    const matches = schedules.filter((s) => ruleMatches(s, parts, roomId));
    if (matches.length === 0)
        return null;
    matches.sort((a, b) => {
        var _a, _b;
        const dp = ((_a = b.priority) !== null && _a !== void 0 ? _a : 0) - ((_b = a.priority) !== null && _b !== void 0 ? _b : 0);
        if (dp !== 0)
            return dp;
        return a.id.localeCompare(b.id);
    });
    return matches[0];
}
export function newScheduleId() {
    const alphabet = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let out = "";
    for (let i = 0; i < 12; i++) {
        out += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    }
    return out;
}
